import * as React from "react";
import {useTranslation} from "react-i18next";
import {getShopId} from "../../../lib/getShopId";
import {getReturnPolicyDays} from "../../../../helpers/getReturnPolicyDays";

const OurStandards: React.FC = () => {
  const {t} = useTranslation();

  return (
    <div className="list-our-standards">
      <div className="h3">{t("checkout.ourStandards")}</div>

      <div className="checkmarks standards">
        <ul>
          <li>
            <i className="icon icon-check--lightgreen">&#160;</i>
            <a href={t("url.privacyLinkAndAnchor")}>{t("general.privacy")}</a>
          </li>
          <li>
            <i className="icon icon-check--lightgreen">&#160;</i>
            {t("checkout.sslEncryption")}
          </li>
          {!!getReturnPolicyDays() && (
            <li>
              <i className="icon icon-check--lightgreen">&#160;</i>
              {t("checkout.withdrawalRight--days", {days: getReturnPolicyDays()})}
            </li>
          )}
          <li>
            <i className="icon icon-check--lightgreen">&#160;</i>
            {t("checkout.fastDelivery")}
          </li>
        </ul>
      </div>

      {/* Only show if it's NOT 'da-DK' 'nl-NL', or 'en-US' (and also 'fr-FR', since no block is rendered. See below) */}
      {![100022, 100029, 100005, 100008].includes(getShopId()) && (
        <div className="logos">
          {/* de-DE */}
          {getShopId() === 100001 && (
            <a
              className="image-link"
              href="https://cert.ehi-siegel.de/webshop/connox-de_4034064?lang=deu"
              title="Zertifizierung aufrufen"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://dashboard.trustprofile.com/banners/4000167/4034064/1699356718.svg"
                width="64"
                height="64"
                alt="Webshop Trustmark and customer reviews"
              />
            </a>
          )}

          {/* de-AT */}
          {getShopId() === 100009 && (
            <a
              className="image-link"
              href="https://www.guetezeichen.at/zertifikate/shopzertifikat/wwwconnoxat/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="sprite sprite-austria-ecg">&#160;</span>
            </a>
          )}

          {/* de-CH or fr-CH */}
          {[100017, 100027].includes(getShopId()) && (
            <a
              className="image-link"
              href="https://www.vsv-versandhandel.ch/members/detail/connox-gmbh/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="sprite sprite-austria-ecg">&#160;</span>
            </a>
          )}

          {/* en-GB */}
          {getShopId() === 100020 && (
            <a
              className="image-link"
              title="SafeBuy Recommended Action: click me to see Retailer Accreditation Certificate for this website (new tab/window)"
              href="https://www.safebuy.org.uk/certificate/93313bbb-8efe-4ca5-83ec-3231711f8ccf.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="icon icon-trust-safebuy">&#160;</span>
            </a>
          )}

          {/* fr-FR is missing!? */}
        </div>
      )}
    </div>
  );
};

export default OurStandards;
